import {
  ClientOrganizationProfileRoleEnum,
  ClientOrganizationTagsEnum
} from '@DigitaleDoerfer/digitale-doerfer-api';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import { BarChartIcon, GroupsIcon } from '@/assets';
import { ListItem } from '@/features/list/components/ListItem';
import { ListSection } from '@/features/list/components/ListSection';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { OrganizationAccessGuard } from '@/shared/components/organization';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = {
  onMembersPress: () => void;
  onStatisticsMailPress: () => void;
};

const MANAGER_ROLES = [ClientOrganizationProfileRoleEnum.Admin];

export const OrganizationDetailManagementSection: FC<Props> = ({
  onMembersPress,
  onStatisticsMailPress
}) => {
  const theme = useAppTheme();
  const { t } = useTranslation(LocalizationNameSpace.ORGANIZATION, {
    keyPrefix: 'organization-detail'
  });
  const rowBackground = theme.colors.surfaceContainerLowest;

  return (
    <ListSection
      title={t('sections.management')}
      style={styles.section}
      headerBackgroundColor="transparent"
    >
      <ListItem
        title={t('rows.members')}
        icon={GroupsIcon}
        backgroundColor={rowBackground}
        onPress={onMembersPress}
      />
      <OrganizationAccessGuard
        roles={MANAGER_ROLES}
        requiredTags={[ClientOrganizationTagsEnum.TerritorialAuthority]}
      >
        <ListItem
          title={t('rows.statisticsMail')}
          icon={BarChartIcon}
          backgroundColor={rowBackground}
          onPress={onStatisticsMailPress}
        />
      </OrganizationAccessGuard>
    </ListSection>
  );
};

const styles = StyleSheet.create({
  section: { backgroundColor: 'transparent' }
});
